import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-091d1b8e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "col-md-12 px-1 py-3 border-bottom"
}
const _hoisted_2 = { class: "row principle_transactions mt-4 px-3" }
const _hoisted_3 = { class: "col-md-12 table-responsive" }
const _hoisted_4 = {
  id: "exA",
  class: "table table-striped table-bordered nowrap w-100"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Month End Dates"),
    /*#__PURE__*/_createElementVNode("th", null, "Interest"),
    /*#__PURE__*/_createElementVNode("th", null, "Interest Paid"),
    /*#__PURE__*/_createElementVNode("th", null, "Balance"),
    /*#__PURE__*/_createElementVNode("th", null, "Merchant Fees"),
    /*#__PURE__*/_createElementVNode("th", null, "Fees On Paid Principle"),
    /*#__PURE__*/_createElementVNode("th", null, "Total Fees Due"),
    /*#__PURE__*/_createElementVNode("th", null, "Total Fees Paid"),
    /*#__PURE__*/_createElementVNode("th", null, "Balance")
  ])
], -1))
const _hoisted_6 = {
  key: 0,
  class: "main_securities"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { colspan: "9" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-center" }, "No records found")
], -1))
const _hoisted_8 = [
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_basic = _resolveComponent("basic")!

  return (_ctx.fum_id!='')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_basic, { myinv_id: _ctx.myinv_id }, null, 8, ["myinv_id"]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("table", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fees, (fee) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    class: "main_securities",
                    key: fee.fee_id
                  }, [
                    _createElementVNode("td", null, _toDisplayString(fee.interest_date), 1),
                    _createElementVNode("td", null, _toDisplayString(fee.interest_amount), 1),
                    _createElementVNode("td", null, _toDisplayString(fee.interest_paid), 1),
                    _createElementVNode("td", null, _toDisplayString(fee.interest_balance), 1),
                    _createElementVNode("td", null, _toDisplayString(fee.interest_merchant_fee), 1),
                    _createElementVNode("td", null, _toDisplayString(fee.interest_principle_fee), 1),
                    _createElementVNode("td", null, _toDisplayString(fee.total_due_fee), 1),
                    _createElementVNode("td", null, _toDisplayString(fee.total_paid_fee), 1),
                    _createElementVNode("td", null, _toDisplayString(fee.interest_fee_balance), 1)
                  ]))
                }), 128)),
                (!_ctx.fees.length)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_6, _hoisted_8))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}